import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getPTagAll = (_params, onSuccess, onError) => {
    _params.filterAndNegative = 'language_code:en';
    _params.orders= 'tag';
    const response = axios.get('v1/admin/product-tag', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getLanguages = (_params, onSuccess, onError) => {
    _params.filterAndNegative = 'language_code:en';
    _params.orders= 'language_name:asc';
    const response = axios.get(`v1/admin/language`, { params: _params });
    return handleResponse(response, onSuccess, onError);
}

export const getPTagById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/product-tag/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createPTag = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/product-tag`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updatePTag = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/product-tag/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeletePTag = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/product-tag/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deletePTag = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/product-tag/${id}`);
    return handleResponse(response, onSuccess, onError);
};